// src/api/index.js

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
const USER_STORAGE_KEY = 'user';
const TOKEN_STORAGE_KEY = 'authToken';

const readJsonFromStorage = (key) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

const getStoredUser = () => readJsonFromStorage(USER_STORAGE_KEY);

const getStoredToken = () => {
  try {
    return localStorage.getItem(TOKEN_STORAGE_KEY);
  } catch (error) {
    return null;
  }
};

const storeAuthSession = ({ user, token }) => {
  if (user) {
    localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
  }

  if (token) {
    localStorage.setItem(TOKEN_STORAGE_KEY, token);
  }
};

const clearAuthSession = () => {
  localStorage.removeItem(USER_STORAGE_KEY);
  localStorage.removeItem(TOKEN_STORAGE_KEY);
};

const buildAuthHeaders = (headers = {}) => {
  const token = getStoredToken();

  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...headers,
  };
};

const apiRequest = async (endpoint, options = {}) => {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  const url = `${API_BASE_URL}${cleanEndpoint}`;
  const isFormData = options.body instanceof FormData;

  const config = {
    method: options.method || "GET",
    headers: {
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...buildAuthHeaders(options.headers),
    },
    ...options,
  };

  if (options.body && !isFormData) {
    config.body = JSON.stringify(options.body);
  }

  try {
    const response = await fetch(url, config);

    if (!response.ok) {
      // Пробуем распарсить JSON для извлечения message
      let errorMessage = `HTTP ${response.status}`;
      try {
        const errorData = JSON.parse(await response.text());
        if (errorData.message) {
          errorMessage = errorData.message;
        }
      } catch {
        // Fallback к тексту ответа
        
      }
      const error = new Error(errorMessage);
      error.status = response.status;
      alert(errorMessage);
      throw error;
    }

    if (options.responseType === 'blob') {
      return await response.blob();
    }

    if (response.status === 204) {
      return { success: true };
    }

    return await response.json();
  } catch (error) {
    console.error("API request failed to:", url, error);
    throw error;
  }
};

export {
  API_BASE_URL,
  apiRequest,
  buildAuthHeaders,
  clearAuthSession,
  getStoredToken,
  getStoredUser,
  storeAuthSession,
};
